import { FC } from 'react';

import { IModuleSliderArrowProps, ModuleSliderArrow } from '~modules/slider/ModuleSliderArrow';

export const ModuleSliderPrevArrow: FC<Omit<IModuleSliderArrowProps, 'direction'>> = props => (
  <ModuleSliderArrow {...props} direction="left" />
);
export default ModuleSliderPrevArrow;
